import { memo } from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { MenuItem } from 'consts/waMessaging';
import { selectIsExportWaMessagingResourceLoading } from 'features/waMessaging/selectors';
import { TableToolbar, type TableToolbarProps } from 'ui/widgets/Table';
import { useWaMessageSetupContext } from './WaMessageSetupProvider';

const AddButton = () => {
    const { open, openCreate } = useWaMessageSetupContext();

    return (
        <Button
            size='small'
            startIcon={<AddIcon />}
            onClick={openCreate}
            disabled={open}
            data-test-id='waMessagesSetups.controls.add'
        >
            Add Setup
        </Button>
    );
};

const Toolbar = (props: Pick<TableToolbarProps, 'onExport'>) => (
    <TableToolbar
        {...props}
        add={AddButton}
        selectIsExportLoading={selectIsExportWaMessagingResourceLoading(MenuItem.WaMessagesSetups)}
        dataTestIdPrefix='waMessagesSetups.table'
    />
);

export default memo(Toolbar);
